import { foundationListboxStyles } from '@genesislcap/foundation-ui';
import { css } from '@microsoft/fast-element';
export const zeroListboxStyles = (context, definition) => css `
  ${foundationListboxStyles(context, definition)}

  :host {
    background: #1f2126;
  }
`;
